import CryptoJS from 'crypto-js';
import defaultImagesByCategory from 'event-user/pages/NationalTravelVendorPage/DefaultImagesbyCategory';

const SECRET_KEY = process.env.REACT_APP_INSTORE_INSERTS_SECRET_KEY;

// got tired of putting this in random files during debugging
// shouldn't really have any references, but keeping here for

// future convenience
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const ensureAsync = (callback) => {
    if (callback.constructor.name === 'AsyncFunction') {
        return callback();
    }

    return new Promise((resolve, reject) => {
        try {
            const val = callback();
            resolve(val);
        } catch (e) {
            reject(e);
        }
    });
};

const maskEmail = (email) => {
    const [localPart, domain] = email.split('@');
    if (localPart.length > 4) {
        const maskedLocalPart = localPart.slice(0, 4) + '*'.repeat(localPart.length - 4);
        return `${maskedLocalPart}@${domain}`;
    } else if (localPart.length < 5 && localPart.length > 1) {
        const maskedLocalPart = localPart.slice(0, localPart.length - 1) + '*'.repeat(1);
        return `${maskedLocalPart}@${domain}`;
    } else return email;
};

const stringReducer = (strName, fixLength) => {
    const truncateVendorName = strName?.slice(0, fixLength);
    if (strName?.length > fixLength) {
        return truncateVendorName?.concat('...');
    }
    return truncateVendorName;
};

const encryptEmail = (email) => {
    console.log('encrypting email:', SECRET_KEY);
    const ciphertext = CryptoJS.AES.encrypt(email, SECRET_KEY).toString();
    return encodeURIComponent(ciphertext);
};

function decodeSpecificCharsFromHtml(str) {
    if (typeof str !== 'string') {
        return str;
    }
    return str
        .replace(/<br>/g, '\n')
        .replace(/&#039;/g, "'")
        .replace(/&quot;/g, '"')
        .replace(/&#92;/g, '\\');
}

function getImageMedia(webstore, index) {
    const categoryDefaults = defaultImagesByCategory[webstore.category] || [];
    const fallbackUrl = categoryDefaults[index % categoryDefaults.length];
    const defaultImage = [
        {
            url: fallbackUrl,
        },
    ];

    if (webstore?.extracted_images && webstore.extracted_images.length > 0) {
        return webstore.extracted_images;
    }

    if (!webstore?.media) {
        return defaultImage;
    }

    const media = webstore?.media ? decodeSpecificCharsFromHtml(webstore.media) : null;
    let images = JSON.parse(media)?.images || [];

    function getImageBaseUrl(baseUrl) {
        return baseUrl.replace('.davidsbridal.com', '-images.davidsbridal.com/');
    }
    let updatedUrl;
    console.log(process.env.REACT_APP_ENVIRONMENT, 'process.env.REACT_APP_ENVIRONMENT');
    if (process.env.REACT_APP_ENVIRONMENT === 'test') {
        console.log('1111111');
        updatedUrl = getImageBaseUrl('https://pearl-test.davidsbridal.com');
    } else if (process.env.REACT_APP_BASE_URL === 'https://pearl.davidsbridal.com') {
        updatedUrl = getImageBaseUrl('https://pearl-prod.davidsbridal.com');
    } else {
        updatedUrl = getImageBaseUrl(process.env.REACT_APP_BASE_URL);
    }
    console.log(updatedUrl, 'updataedsd');
    if (images.length > 0) {
        images = images.map((image) => {
            console.log('2222222');
            return {
                url: updatedUrl + image.name,
            };
        });
    }
    return images;
}

export {
    sleep,
    ensureAsync,
    maskEmail,
    stringReducer,
    encryptEmail,
    getImageMedia,
    decodeSpecificCharsFromHtml,
};
